import GitHubLogin from './GitHubLogin';

export default GitHubLogin;